export const PRESENCE_FETCH_SUCCESSFULLY = 'presence.PRESENCE_FETCH_SUCCESSFULLY';
export const PRESENCE_FETCH_FAILED = 'presence.PRESENCE_FETCH_FAILED';
export const PRESENCE_CHILD_ADDED = 'presence.PRESENCE_CHILD_ADDED';
export const PRESENCE_CHILD_ADDED_FAILED = 'presence.PRESENCE_CHILD_ADDED_FAILED';
export const PRESENCE_CHILD_REMOVED = 'presence.PRESENCE_CHILD_REMOVED';
export const PRESENCE_CHILD_REMOVED_FAILED = 'presence.PRESENCE_CHILD_REMOVED_FAILED';